export default "__VITE_ASSET__80cb8dc4__"